import type { FixtureRoster, FixtureRosterResources, FixtureRosterResponse } from "~types/fixtureRoster";
import type { RoleResponse } from "~types/role";

export const transformFixtureRoster = (response: FixtureRosterResponse, rolesResponse?: RoleResponse) => {
  const resources: FixtureRosterResources | undefined = response?.includes?.resources;
  const captains = rolesResponse?.data.map((role) => ({
    entityId: role.entityId,
    role: role.role,
    roleId: role.roleId,
    personId: role.personId,
  }));
  return (
    response?.data?.map((item: FixtureRoster) => {
      const captain = captains?.find((captain) => captain.entityId === item.entityId && captain.personId === item.personId);
      return {
        ...item,
        entity: resources?.[item.entity?.resourceType ?? ""]?.[item.entity?.id ?? ""],
        person: resources?.[item.person?.resourceType ?? ""]?.[item.person?.id ?? ""],
        isCaptain: !!captain,
        captainRoleId: captain?.roleId,
      };
    }) || []
  );
};
